import { Tables } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const getCrmById = async (crmId: Tables<"crm">["id"]) => {
    return await supabase
        .from('crm')
        .select(`*,crm_project(*,crm_config(*)), organisation_crm!inner(*)`)
        .eq('id', crmId)
        .throwOnError()
        .maybeSingle()
        .then(res => res.data);
}